/**
 * Restricts the given value to: `min <= value <= max`
 *
 * Why this does not yet exist in the Math namespace is beyond me.
 */
export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}
